import React from 'react';
import dayjs from 'dayjs';
import step1 from '../assets/images/frame-5.1.svg';
import step2 from '../assets/images/frame-5.2.svg';
import step3 from '../assets/images/frame-5.3.svg';
import step4 from '../assets/images/frame-5.4.svg';
import step5 from '../assets/images/frame-5.5.svg';
import dragImage from '../assets/images/image-drag.png';


import calendarIcon from '../assets/images/calendar.svg';
import callbackIcon from '../assets/images/btn-icon-5.svg';

import frame6_1 from '../assets/images/frame-6.1.svg';
import frame6_2 from '../assets/images/frame-6.2.svg';
import frame6_3 from '../assets/images/frame-6.3.svg';
import frame6_4 from '../assets/images/frame-6.4.svg';
import frame6_5 from '../assets/images/frame-6.5.svg';

const generateCalendarWeeks = (year, month) => {
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const weeks = [];
  let week = new Array(firstDay).fill('');
  for (let d = 1; d <= daysInMonth; d++) {
    week.push(d.toString());
    if (week.length === 7) {
      weeks.push(week);
      week = [];
    }
  }
  if (week.length > 0) {
    while (week.length < 7) week.push('');
    weeks.push(week);
  }
  return weeks;
};

const WhyTrustRest = () => {
  const today = dayjs();
  const weeks = generateCalendarWeeks(today.year(), today.month());

  // Dummy highlighted days for now
  const highlightDays = {
    '6': 'bg-success text-white rounded fw-bold',
  };

  const WEEKDAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

return (
<section className="why-trust-rest">
<div className="frame">
<div className="container text-center my-5">
<div className="row justify-content-center">
<div className="col-lg-8">
<h2 className="fw-bold display-5 text-dark mb-3">Why Trust Rest Assured?</h2>
<p className="lead text-secondary">
We're committed to providing a service you can truly rely on, whether you're oceans away or just
around the corner.
</p>
</div>
</div>
</div>
<div className="div">
{/* Left - Verification Steps */}
<div className="div-2 verified-service-wrapper"> {/* 👈 Add a better flex wrapper class */}
<div className="content">
<div className="most-popular-tag">
<div className="text-wrapper-2">Verification</div>
</div>

<div className="container px-3">
  <h3 className="fw-bold text-dark fs-4 fs-md-3 lh-base mb-2 text-break w-100">
    Verified Service: See the Difference
  </h3>
  <p className="text-secondary fs-6 lh-sm mb-3 text-break w-100">
    We ensure transparency by providing proof of every service. Our professionals capture pre- and post-service records, so you know exactly what's done even when you're away.
  </p>
</div>

<img 
  className="image-drag img-fluid d-block d-md-none mx-auto my-3" 
  src={dragImage} 
  alt="decorative"
/>

<div className="row row-cols-1 g-4 mt-5">
  {[step1, step2, step3, step4, step5].map((icon, index) => (
    <div key={index} className="col">
      <div className="card h-100 border-0 shadow-sm p-3">
        <div className="d-flex flex-wrap align-items-center gap-3">
          <img
            src={icon}
            alt={`Step ${index + 1}`}
            style={{
              width: '48px',
              height: '48px',
              flexShrink: 0
            }}
          />
          <p
            className="fw-medium text-muted mb-0 flex-grow-1"
            style={{ minWidth: 0, wordBreak: 'break-word' }}
          >
            {
              [
                'Professional arrives at the location',
                'Shares pre-service images',
                'Completes the service as per request',
                'Shares post-service images',
                'You receive a summary confirmation'
              ][index]
            }
          </p>
        </div>
      </div>
    </div>
  ))}
</div>


</div>
<img 
  className="image-drag img-fluid d-none d-md-block mx-auto my-3" 
  src={dragImage} 
  alt="decorative"
/>

</div>
{/* Right - Scheduling */}
<div className="div-3">
<div className="scheduling">
<div className="calendar-container">
<div className="d-flex justify-content-between align-items-center px-3 py-2 border rounded bg-light">
  <div className="change-month-title h5 mb-0 fw-semibold text-dark">
    June 2025
  </div>
</div>

<div className="my-4 px-2" style={{ overflowX: 'auto' }}>
  {/* Weekdays Header (Only Once) */}
  <div className="row text-center fw-semibold text-secondary border-bottom pb-2 mb-2">
    {WEEKDAYS.map((day, idx) => (
      <div key={idx} className="col text-uppercase small">
        {day}
      </div>
    ))}
  </div>

  {/* Calendar Grid */}
  <div className="d-flex flex-column w-100 overflow-auto">
  <div className="month-grid">
    {weeks.map((week, wIdx) => (
      <div key={wIdx} className="row text-nowrap mb-2 gx-0">
        {week.map((d, dIdx) => {
          const cellClass = highlightDays[d] || 'text-muted';
          return (
<div key={dIdx} className="col p-1 text-nowrap">
  <div className={`py-2 ${cellClass} small`}>{d}</div>
</div>

          );
        })}
      </div>
    ))}
  </div>
</div>

</div>

</div>

{/* Notification Card */}
<div className="notification position-absolute start-0" style={{ top: '471px', left: '20px', maxWidth: '320px' }}>
  <div className="d-flex align-items-start gap-3 mb-2">
    <div>
      <div className="fw-semibold text-white h6 mb-1">Your home is ready!</div>
      <div className="text-white-50 small text-wrapper-8">Just now</div>
    </div>
  </div>
  <div className="desc-wrapper">
    <p className="desc text-white mb-0">Cleaning completed as scheduled. You'll receive photos shortly.</p>
  </div>
</div>


{/* Upcoming Cleaning */}
<div className="upcoming-cleaning position-absolute rounded shadow-sm p-4">
  {/* Header Row: Calendar Icon + Title */}
  <div className="d-flex align-items-center mb-3">
    <div className="frame-wrapper me-3">
      <img className="frame-2" src={calendarIcon} alt="Calendar" />
    </div>
    <div className="title-description-2">
      <div className="description">Upcoming Cleaning</div>
      <div className="title-2">June 06, 2025</div>
    </div>
  </div>

  {/* Service Info Block */}
  <div className="frame-3">
    <div className="frame-4">
      <div className="status">
        <div className="status-tag">
          <div className="text-wrapper-9">Confirmed</div>
        </div>
      </div>
      <div className="frame-5">
        <div className="desc-2">Deep Cleaning Service</div>
        <p className="text-wrapper-8">1 day before your arrival</p>
      </div>
    </div>

    {/* Action Button */}
    <div className="delivered">
      <div className="primary-btn-small">
        <div className="text-wrapper-10">View Details</div>
        <img className="btn-icon" src={callbackIcon} alt="Callback" />
      </div>
    </div>
  </div>
</div>

</div>

{/* Right content summary */}
<div className="content">
<div className="most-popular-tag"><div className="text-wrapper-2">Scheduling</div></div>
<div className="container px-3">
  <h3 className="fw-bold text-dark fs-4 fs-md-3 lh-base mb-2 text-break w-100">
  Plan Ahead: Hassle-Free Homecoming  </h3>
  <p className="text-secondary fs-6 lh-sm mb-3 text-break w-100">
  Returning home for a visit? Schedule your cleaning in advance and arrive to a fresh, spotless space.
  Let us handle your home's upkeep while you're away.  </p>
</div>

<div className="steps">
  {[frame6_1, frame6_2, frame6_3, frame6_4, frame6_5].map((img, index) => (
    <div key={index} className="service-card mb-3">
      <div className="d-flex align-items-start gap-3">
        <img
          src={img}
          alt={`Schedule step ${index + 1}`}
          width="40"
          height="40"
          className="flex-shrink-0"
        />
        <p className="mb-0 fw-medium text-muted text-break" style={{ fontSize: '18px', lineHeight: '30px' }}>
          {
            [
              'Select your cleaning schedule in advance',
              'A background-verified professional is assigned',
              'Service is completed before your arrival',
              'You receive a WhatsApp confirmation & images',
              'Arrive at a freshly cleaned, well maintained home'
            ][index]
          }
        </p>
      </div>
    </div>
  ))}
</div>

</div>
</div>
</div>
</div>
</section>
);
};
export default WhyTrustRest;
